import ServiceOffers from "@/components/landing/ServiceOffers";
import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useRef } from "react";
import "@/App.css";
import Seo from "@/components/Seo";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Services from "@/components/landing/Services";
import Properties from "@/components/landing/Properties";
import CtaSplit from "@/components/landing/CtaSplit";
import WhyShaydan from "@/components/landing/WhyShaydan";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingWhatsApp from "@/components/landing/FloatingWhatsApp";
import LegalPage from "@/pages/LegalPage";
import AdminPage from "@/pages/AdminPage";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    fetch(`${API}/auth/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (r) => {
        if (!r.ok) throw new Error("auth failed");
        return r.json();
      })
      .then((user) => navigate("/admin", { replace: true, state: { user } }))
      .catch(() => navigate("/admin", { replace: true, state: { authError: true } }));
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy">
      <span className="font-head text-cream/70">جاري تسجيل الدخول...</span>
    </div>
  );
}

const HomePage = () => (
  <>
    <Seo
      title="شيادن الأصول العقارية | رؤيتك العقارية تبدأ من أصل ثابت"
      siteName="شيادن الأصول العقارية"
      description="شيادن الأصول العقارية — حلول احترافية في التسويق العقاري والوساطة العقارية والتأجير للغير. تواصل معنا عبر واتساب 0551799245."
      jsonLd={{
        "@context": "https://schema.org",
        "@type": "RealEstateAgent",
        name: "شيادن الأصول العقارية",
        alternateName: "SHIYADN REAL ESTATE ASSETS",
        telephone: "+966551799245",
        description:
          "حلول احترافية في التسويق العقاري والوساطة العقارية والتأجير للغير.",
      }}
    />
    <Header />
    <main>
      <Hero />
      <EditorialMarquee />
      <About />
      <Services />
      <ServiceOffers />
      <WhyShaydan />
      <Properties />
      <CtaSplit />
      <Contact />
    </main>
  </>
);

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<LegalPage page="privacy" />} />
        <Route path="/terms" element={<LegalPage page="terms" />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingWhatsApp />}
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.lenis = null;
    };
  }, []);

  return (
    <div dir="rtl" className="bg-cream font-body text-ink">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
